import { createStore, combineReducers, applyMiddleware } from 'redux';
import rootReducer from './redux/rootReducer';
import { createLogger } from 'redux-logger';
import { connectRouter } from 'connected-react-router';
import { compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './redux/rootSaga';
import { history } from './history.js';
import { routerMiddleware } from 'react-router-redux';
import { persistStore } from 'redux-persist';

const logger = createLogger();
const rootReducerWithHistory = combineReducers({
	router: connectRouter(history),
	rootReducer,
});
const routersMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const middlewares =
	process.env.NODE_ENV === 'production'
		? [sagaMiddleware, routersMiddleware]
		: [sagaMiddleware, logger, routersMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
	rootReducerWithHistory,
	composeEnhancers(applyMiddleware(...middlewares)),
);

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);
